import { createSlice } from 'utils/@reduxjs/toolkit';
import { AddToCartState } from './types';
import { reducers } from './reducers';

export const initialState: AddToCartState = {
  data: false,
  isLoading: false,
  error: null,
};

const slice = createSlice({
  name: 'addToCart',
  initialState,
  reducers,
});

export const { actions: addToCartActions } = slice;
export const { reducer: addToCartReducer } = slice;
